export default class UtilService {
  constructor(source) {
    this.source = source
  }
  Loading(value) {
    let source = this.source
    while (source.loadingMainPage === undefined && source.$parent !== undefined) {
      source = source.$parent
    }
    source.loadingMainPage = value
  }

  VerificarHotelSelecionado (hotelSelecionado, ignoreHotelNull) {
    let body = document.getElementsByTagName('BODY')[0]
    let className = 'sidebar-lg-show'
    if(!hotelSelecionado && !ignoreHotelNull) {
      body.classList.remove(className)
      document.getElementById('btnSidebarHide').style = 'display:none'
    } else if((hotelSelecionado && !body.classList.contains(className)) || ignoreHotelNull) {
      body.classList.add(className)
      document.getElementById('btnSidebarHide').style = 'display:block'
    }
  }

  RedirectLogin(getToken) {
    console.log("Entrou em RedirectLogin")
    sessionStorage.clear();
    localStorage.clear();
    let urlRedirect = window.location.protocol + '//' + window.location.host + window.location.pathname
    if(getToken) {
      window.location.href = process.env.VUE_APP_URL_LOGIN + '/account/getToken?returnUrl=' + urlRedirect
    } else {
      window.location.href = process.env.VUE_APP_URL_LOGIN + '/Account/Logout?returnUrl=' + urlRedirect
    }
  }

  RedirectLogout() {
    alert('Redirecionando para Login.')
    localStorage.clear();
    sessionStorage.clear();
    let urlRedirect = window.location.protocol + '//' + window.location.host + window.location.pathname
    window.location.href = process.env.VUE_APP_URL_LOGIN + '/Account/Logout?returnUrl=' + urlRedirect
  }
}
